import Cookies from 'js-cookie'

import { UNREGISTERED_USER_TOKEN_STORAGE_KEY } from '@/constants/unregistered-user'

const UNREGISTERED_USER_TOKEN_EXPIRATION_DAYS = 1

export const getUnregisteredUserToken = () => Cookies.get(UNREGISTERED_USER_TOKEN_STORAGE_KEY)

export const deleteUnregisteredUserToken = () => Cookies.remove(UNREGISTERED_USER_TOKEN_STORAGE_KEY)

export const setUnregisteredUserToken = (token: string) =>
    Cookies.set(UNREGISTERED_USER_TOKEN_STORAGE_KEY, token, { expires: UNREGISTERED_USER_TOKEN_EXPIRATION_DAYS })
